export default {"src":"/_next/static/media/poolEndIn.bc588fd9.svg","height":24,"width":24};